import buildPageUrl from '../page/buildPageUrl';
import {flatProductList} from './productUtil';

/**
 *
 * @param {Object} [user]
 * @param {boolean} [shouldClone]
 * @param {boolean} [cloneOnSameDay]
 * @param {Object} [products]
 * @param {Object} [params]
 * @returns {string}
 */
export default function startNewGuide({ user = {}, shouldClone, cloneOnSameDay, products, params = {}} = {}) {
  const uri = buildPageUrl({ type: 'landing' });
  const {
    uuid,
    assignment,
    timestamp
  } = user;

  const isSameDay = (guideDate) => {
    const today = new Date();
    return (
      guideDate.getFullYear() === today.getFullYear() &&
      guideDate.getMonth() === today.getMonth() &&
      guideDate.getDate() === today.getDate()
    );
  };
  const shouldBeCloned = assignment && shouldClone ? cloneOnSameDay || !isSameDay(new Date(timestamp)) : false;

  const searchParams = new URLSearchParams();
  if (shouldBeCloned) {
    searchParams.append('cloneFrom', uuid);
    searchParams.append('AssociateID', assignment.employee.employeeId);
    searchParams.append('BranchID', assignment.branch.clientId);
    searchParams.append('existingProducts', (flatProductList(products) || []).map(p => p.id).join());
  } else if (uuid) {
    searchParams.append('userId', uuid);
  }

  for (const key in params) {
    if (params[key]) {
      searchParams.append(key, params[key]);
    }
  }

  return `${ uri }?${ searchParams.toString() }`;
}
